<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent: 00em;">Special gratitude to four men who give far more than they take from this world.</p><br/>
<p style="text-indent: 00em;">Dr Erik Patel, a great scientist, humanitarian, and friend.</p><br/>
<p style="text-indent: 00em;">Rabary Desire whose knowledge and actions are an inspiration those in this world who prefer to build rather than tear down.</p><br/>
<p style="text-indent: 00em;">Dr Steve Goodman for your thirty plus years of work in Madagascar building institutions and advancing knowledge, and for taking the time to talk to me.</p><br/>
<p style="text-indent: 00em;">And to Floris Saula, a husband, father, and man who represents a more prosperous and resilient future for the people of Madagascar.</p><br/>
<p style="text-indent: 00em;">This book would not be without your generosity and hospitality.</p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?a2abe7ce